var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cube-tab-bar',{staticClass:"tab",attrs:{"data":_vm.tabs},on:{"change":_vm.changeHandler},model:{value:(_vm.activeVal),callback:function ($$v) {_vm.activeVal=$$v},expression:"activeVal"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0755b3f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/FootNav.vue
// module id = null
// module chunks = 